module.exports = __webpack_public_path__ + "media/img/apple-icon-60x60-722dd2af1a94ed03756b8a20c8551e21.png";